<template>
  <div class="app-button-group">
    <slot />
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/button-group";
</style>